<template>
    <div class="app help-center" :dir="direction">
        <app-header />
        <sub-header title="help_center" />
        <help-center-main-body />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AppHeader from '../components/Header'
import SubHeader from '../components/common/SubHeader'
import HelpCenterMainBody from '../components/help-center/HelpCenterMainBody'

export default {
    name: 'HelpCenterView',
    components: { SubHeader, AppHeader, HelpCenterMainBody },
    computed: {
        ...mapGetters({
            direction: 'locale/direction'
        })
    }
}
</script>
